class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = 0;
    this.scrollThreshold = 5;
    this.isHidden = false;
  }

  connectedCallback() {
    this.header = this.querySelector('header');
    this.isHomepage = this.dataset.isHomepage === 'true';
    this.headerGroup = document.getElementById('shopify-section-group-header-group') || this.closest('.shopify-section');

    if (this.headerGroup) {
      this.headerGroup.style.position = 'sticky';
      this.headerGroup.style.top = '0';
      this.headerGroup.style.zIndex = '100';
      this.headerGroup.style.transition = 'transform 0.2s ease';
      this.headerGroup.style.willChange = 'transform';

      if (this.isHomepage) {
        this.resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            const height = entry.contentRect.height;
            if (height > 0) {
               this.headerGroup.style.marginBottom = `-${height}px`;
            }
          }
        });
        this.resizeObserver.observe(this.header);
      }
    }

    this.lastScrollY = window.scrollY || 0;
    this.updateSortBarOffset();

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  isMobileViewport() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  updateSortBarOffset() {
    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const offset = this.isHidden ? 0 : headerHeight;
    document.documentElement.style.setProperty('--collection-sort-bar-top', `${offset}px`);
  }

  setHidden(hidden) {
    if (this.isHidden === hidden) return;
    this.isHidden = hidden;
    if (this.headerGroup) {
      this.headerGroup.style.transform = hidden ? 'translateY(-100%)' : 'translateY(0)';
    }
    this.updateSortBarOffset();
  }

  onScroll() {
    if (!this.headerGroup) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const groupRect = this.headerGroup.getBoundingClientRect();
    const isSticking = groupRect.top <= 0;

    if (scrollTop > 0 && isSticking) {
      this.header.classList.add('is-scrolled');
    } else {
      this.header.classList.remove('is-scrolled');
    }

    this.updateHeaderVisibility(scrollTop);
    this.lastScrollY = scrollTop;
  }

  updateHeaderVisibility(scrollTop) {
    if (!this.isMobileViewport()) {
      this.setHidden(false);
      return;
    }

    const headerHeight = this.header ? this.header.offsetHeight : 80;
    if (scrollTop <= headerHeight) {
      this.setHidden(false);
      return;
    }

    const delta = scrollTop - this.lastScrollY;
    if (Math.abs(delta) < this.scrollThreshold) return;

    if (delta > 0) {
      this.setHidden(true);
    } else {
      this.setHidden(false);
    }
  }
}

customElements.define('sticky-header', StickyHeader);
